import { text_mod_90 } from "../text/Text.js";

export const module90 = {
  title: "Текст-опис",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_90,
    },
  ],
};
